import React from 'react';

// Spinner bileşeninin propları
interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg'; // Boyut seçenekleri
  color?: string;           // Renk (Tailwind sınıfı veya CSS değişkeni)
}

export const Spinner: React.FC<SpinnerProps> = ({ size = 'md', color = 'border-blue-500' }) => {
  let sizeClasses = '';
  switch (size) {
    case 'sm': sizeClasses = 'h-5 w-5 border-2'; break;
    case 'lg': sizeClasses = 'h-24 w-24 border-4'; break;
    default: sizeClasses = 'h-8 w-8 border-[3px]'; break;
  }

  return (
    <div
      className={`animate-spin rounded-full ${sizeClasses} border-solid card ${color} border-t-transparent`}
      role="status"
    >
      <span className="sr-only">Yükleniyor...</span>
    </div>
  );
};
